import { CaArea } from '../../core';
import { currentState } from '../state';

export function addFocus(key: string, focus: string, phrase: string): void {
    const state = currentState();

    const value: CaArea = {
        name: null,
        label: focus,
        description: null,
        displayOrder: null,
        maxScore: null,
        doNotEvaluate: null,
        proTips: null,
        evaluatedBool: null,
        evaluatedReasoning: null,
        score: null,
        collapsedProTips: null,
        phrase,
    };
    const group = state.caResult.groups.find((e) => e.name === key);
    group.areas.push(value);
    group.last = value;
}
